enum MapsTypes {
  RequestImgUrl = 'maps.imgUrl.request',
  RequestImgUrlSuccess = 'maps.imgUrl.request.success',
  RequestImgUrlFailure = 'maps.imgUrl.request.failure',
}

export { MapsTypes };
